export const downloadTemplate = (path: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = path;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);

  link.click();
  document.body.removeChild(link);
};

export const handleAdminLogout = () => {
  localStorage.removeItem("USER");
  localStorage.removeItem("access-token");
  localStorage.removeItem("currency");

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};
